import { createSlice } from "@reduxjs/toolkit";
import { fetchHistoryLogsAsync } from "../actions/historyLogsActions";

type InitialState = {
  historyLogsLoading: boolean;
  historyLogsData: any[];
  historyLogsError: string | null;
  page: number;
  hasMore: boolean;
};

const initialState: InitialState = {
  historyLogsLoading: false,
  historyLogsData: [],
  historyLogsError: null,
  page: 1,
  hasMore: true,
};

const historyLogsSlice = createSlice({
  name: "historyLogsSlice",
  initialState,
  reducers: {
    resetHistoryLogs: (state) => {
      state.historyLogsData = [];
      state.page = 1;
      state.hasMore = true;
      state.historyLogsError = null;
    },
     clearHistoryLogsData: (state) => {
    state.historyLogsData = [];
  },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHistoryLogsAsync.pending, (state) => {
        state.historyLogsLoading = true;
        state.historyLogsError = null;
      })
      .addCase(fetchHistoryLogsAsync.fulfilled, (state, action) => {
        state.historyLogsLoading = false;
        const newData = action.payload?.results || [];

        if (newData.length === 0) {
          state.hasMore = false; // stop further API calls
        } else {
          state.historyLogsData = [...state.historyLogsData, ...newData];
          state.page += 1; // increment page only after successful fetch
        }
      })
      .addCase(fetchHistoryLogsAsync.rejected, (state, action) => {
        state.historyLogsLoading = false;
        state.historyLogsError = action.payload as string;
      });
  },
});

export const { resetHistoryLogs,clearHistoryLogsData } = historyLogsSlice.actions;
export default historyLogsSlice.reducer;
